<template>
  <div class="login">
    <!-- <Header /> -->
    <b-container class="login-container">
      <b-row class="justify-content-md-start back-nav">
        <b-link href="https://invesnow.id"
          ><b-icon class="mx-2" icon="chevron-left"></b-icon
          ><span>Kembali</span></b-link
        >
      </b-row>
      <b-row class="justify-content-center">
        <div>
          <b-card-group deck>
            <b-card>
              <h1>Masuk ke akun Anda</h1>
              <template>
                <div>
                  <form action="" method="POST" @submit.prevent="store">
                    <h3 class="login-label">Email</h3>
                    <vs-input
                      id="email"
                      type="email"
                      class="mb-2 mr-sm-2 mb-sm-0"
                      v-model="form.email"
                      required
                    />
                    <div class="my-2" v-if="emailNotFoundShow">
                      <p>Email belum terdaftar</p>
                    </div>
                    <b-row>
                      <b-col>
                        <h3 class="login-label">Password</h3>
                      </b-col>
                      <b-col class="text-right login-label mb-2">
                        <b-link
                          class="forgot-password-link"
                          to="/forgot-password"
                          >Lupa password?</b-link
                        >
                      </b-col>
                    </b-row>
                    <div class="row">
                      <div class="col-9">
                        <vs-input
                          id="password"
                          type="password"
                          v-show="!showPass"
                          class="mb-2 mr-sm-2 mb-sm-0"
                          v-model="form.password"
                          required
                        />
                        <vs-input
                          id="password"
                          type="text"
                          v-show="showPass"
                          class="mb-2 mr-sm-2 mb-sm-0"
                          v-model="form.password"
                          required
                        />
                      </div>
                      <div class="col-3">
                        <b-button
                          @click="showPass = !showPass"
                          block
                          class="btn-show-password py-2"
                        >
                          <div v-show="!showPass">
                            <b-icon icon="eye"></b-icon>
                          </div>
                          <div v-show="showPass">
                            <b-icon icon="eye-slash"></b-icon>
                          </div>
                        </b-button>
                      </div>
                    </div>

                    <div class="my-2" v-if="authenticationFailedShow">
                      <p>
                        Password yang Anda masukkan salah. <br />
                        Coba lagi atau klik “Lupa Password?”
                      </p>
                    </div>
                    <!-- <div class="my-2" v-if="somethingWentWrongShow">
                                      <p>Terjadi kesalahan saat login. Silahkan hubungi cs kami</p>
                                    </div> -->
                    <div class="my-2" v-if="emailNotVerifiedShow">
                      <p>
                        Email belum terverifikasi <br />
                        Silahkan cek email, dan lakukan verifikasi dengan
                        memasukkan OTP
                      </p>
                    </div>
                    <!-- <template>
                                    <div class="remember-me-checkbox py-3">
                                      <vs-checkbox
                                      >Ingat saya </vs-checkbox>                                      
                                    </div>
                                </template>                                 -->
                    <div class="row justify-content-center">
                      <div class="col-lg-12 col-md-6 pt-4">
                        <b-button
                          block
                          :disabled="loading"
                          type="submit"
                          @click="store()"
                          class="btn-tertiary py-2"
                        >
                          <div v-if="loading">
                            <div class="spinner-border spinner-border-sm"></div>
                            Loading
                          </div>
                          <div v-else>Login</div>
                        </b-button>
                      </div>
                    </div>
                  </form>
                </div>
              </template>
              <b-row class="justify-content-md-center dont-have-account-row">
                <div class="dont-have-account">
                  <span
                    >Belum punya akun?
                    <b-link class="sign-up-link" to="/register"
                      >Register</b-link
                    >
                  </span>
                </div>
              </b-row>
            </b-card>
          </b-card-group>
          <b-row class="justify-content-md-center licensed">
            <div class="col-lg-3 col-md-6">
              <div class="license-text">
                <span>Berizin dan Diawasi oleh</span>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="ojk-logo ml-n4 mt-n1">
                <img
                  class="ojk-logo-image"
                  src="@/assets/img/login/ojk-logo.webp"
                  alt=""
                />
              </div>
            </div>
          </b-row>
        </div>
      </b-row>
    </b-container>
    <!-- <Footer4 /> -->
  </div>
</template>

<script>
// import Header from "@/components/partials/header/Header.vue";
// import Footer4 from "@/components/partials/footer/Footer4.vue";

import { mapActions } from "vuex";

import { email } from "vuelidate/lib/validators";

export default {
  name: "Home",
  metaInfo: {
    title: "Login | Invesnow.id",
  },
  // components: {
  //   Header,
  //   Footer4,
  // },
  mounted() {
    document.title = "Login | Invesnow.id";
  },
  validations: {
    email: {
      email,
    },
  },
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      emailNotFoundShow: false,
      emailNotVerifiedShow: false,
      authenticationFailedShow: false,
      loading: false,
      processing: false,
      showPass: false,
    };
  },
  methods: {
    ...mapActions({
      login: "auth/login",
    }),
    async store() {
      if (!this.processing) {
        this.processing = true;
        try {
          await this.login(this.form);
          this.loading = !false;
          // this.$router.back();
          window.location.href = "/portfolio";
          // this.$router.replace('/portfolio')
        } catch (e) {
          if (e.response.data.meta.message == "Email is not verified") {
            this.processing = false;
            this.emailNotFoundShow = false;
            this.authenticationFailedShow = false;
            this.emailNotVerifiedShow = e.response.data.meta.message;
            this.loading = !false;
            window.setTimeout(function () {
              window.location.href = "/verification";
            }, 2000);
          } else if (e.response.data.meta.message == "Email not found") {
            this.processing = false;
            this.emailNotVerifiedShow = false;
            this.authenticationFailedShow = false;
            this.emailNotFoundShow = e.response.data.meta.message;
          } else if (e.response.data.data.message == "Unauthorized") {
            this.processing = false;
            this.emailNotFoundShow = false;
            this.emailNotVerifiedShow = false;
            this.authenticationFailedShow = e.response.data.data.message;
          } else if (e.response.data.data.message == "Validation Error") {
            this.processing = false;
            this.emailNotFoundShow = false;
            this.emailNotVerifiedShow = false;
          }else{
            window.location.reload()
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  background: #f3f4f6;
}
.login-container {
  padding-top: 140px;
  padding-bottom: 80px;
}

h1 {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: #111827;
}

h3 {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: #4b5563;
}

span {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #4f566b;
}

p {
  font-family: $inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #e53e3e;
}

.vs-con-input-label {
  width: 100%;
}

.con-vs-checkbox {
  justify-content: start;
  margin: 0;
}

.login-label {
  padding-top: 16px;
}

.forgot-password-link {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #6b7280;
  text-decoration: none;
}

.has-search .form-control {
  padding-left: 2.375rem;
}

.has-search .form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 2.375rem;
  height: 2.375rem;
  line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
}

.back-nav {
  padding: 0px 240px 20px 308px;

  a {
    font-family: $inter;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;

    color: #6b7280;
    text-decoration: none;
  }
}

.remember-me {
  padding-top: 16px;
  padding-bottom: 16px;
}

.custom-control-label {
  font-family: $inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #3c4257;
}

.custom-control-label:before {
  background-color: #ee503f !important;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #ee503f !important;
}

.card-body {
  padding: 48px;
  box-shadow: 0px 10px 15px rgba(107, 114, 128, 0.1),
    0px 4px 6px rgba(107, 114, 128, 0.05);
  border-radius: 5px;
  width: 500px;
}

.form-control:focus {
  outline: none !important;
  border: 1px solid !important;
  box-shadow: none !important;
}

.dont-have-account {
  padding-top: 28px;
}

.sign-up-link {
  font-family: $inter;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  color: #ee503f;
  text-decoration: none;
}

.licensed {
  padding-top: 30px;
}

.license-text {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #1f2937;
}

.ojk-logo-image {
  width: 120px;
}

.modal-login {
  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    text-align: center;
    color: black;
  }
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    text-align: center;
    color: #4b5563;
  }
}

@media only screen and (max-width: 768px) {
  .login-container {
    padding-bottom: 60px;
  }

  .back-nav {
    padding: 0px 240px 20px 8px;
  }
  .card-body {
    width: 100%;
  }
  .forgot-password-link {
    font-size: 10px;
  }
  .dont-have-account-row {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .licensed {
    text-align: center;
  }
  .ojk-logo-image {
    margin-top: 20px;
  }
}

@media only screen and (min-width: 1366px) {
  .login-container {
    padding-bottom: 300px;
  }
}
</style>
